/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useEffect, useState } from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { useNavigate, useParams } from 'react-router-dom';

import NavbarWrapper from 'components/layout/NavbarWrapper';
import TabPanel from 'components/shared/atoms/TabPanel';
import TabButton from 'components/shared/atoms/button/TabButton';
import StudentListTable from 'components/shared/molecules/StudentListTable';
import BookIcon from 'assets/svgs/ts/BookIcon';
import StudentIcon from 'assets/svgs/ts/StudentIcon';
import StudentReportIcon from 'assets/svgs/ts/StudentReportIcon';
import 'styles/components/pages/teacherClass.scss';
import QuizClassOverview from 'components/shared/molecules/QuizClass/QuizClassOverview';
import {
  useGeTeacherClassByIdQuery,
} from 'store/ApiCall/classesApiCall';
import CircularLoader from 'components/shared/molecules/Loader';
import QuizReportsByClass from 'components/shared/molecules/QuizReportsByClass';
import clsx from 'clsx';
import { SettingsIcon } from 'assets/svgs/ts/SettingsIcon';
import TeacherAccess from '../shared/molecules/ClassSettings/TeacherAccess';

export default function TeacherClassPage(): JSX.Element {
  const navigate = useNavigate();
  const { classId } = useParams();
  const [user, setUser] = useState<any>();

  const [tabValue, setTabValue] = React.useState(1);

  const handleChange = (newValue: number): void => {
    setTabValue(newValue);
  };

  // API call for class information
  const { data, isLoading: isGettingClassInformation, refetch } = useGeTeacherClassByIdQuery(classId);

  useEffect(() => {
    const interval = setInterval(() => {
      refetch();
    }, Number(process.env.REACT_APP_REFETCH_CLASS_INFORMATION));

    return () => { clearInterval(interval); };
  }, [refetch]);

  useEffect(() => {
    setUser(JSON.parse(localStorage.getItem('user') ?? ''));
  }, [])

  if (isGettingClassInformation) return <CircularLoader />;

  return (
    <div className='classPageRoot'>
      <NavbarWrapper name={((): JSX.Element => (
        <span className='navbarTitle'>
          <div className='linkElement' onClick={(): void => { navigate(-1); }}>
            My Classes
          </div>
          <span className='seperator'>{'>'}</span>
          <span className='currentElement'>
            {data?.data.class.name}
          </span>
        </span>
      ))()}
      >
        <div className='pageContent'>
          <div className='tabBar'>
            <Tabs onChange={(event, newValue: number): void => { handleChange(newValue); }} value={tabValue}>
              <Tab
                label={(
                  <TabButton
                    icon={<BookIcon className={clsx(tabValue === 1 ? 'fill-black' : 'fill-mono-dull-light')} />}
                    label='Overview'
                  />
                )}
                value={1}
                disableRipple
                className='muiTab'
              />
              <Tab
                label={<TabButton icon={<StudentIcon className={clsx(tabValue === 2 ? 'fill-black' : 'fill-mono-dull-light')} />} label='Students' />}
                value={2}
                disableRipple
                className='muiTab'
              />
              <Tab
                label={<TabButton icon={<StudentReportIcon className={clsx(tabValue === 3 ? 'fill-black' : 'fill-mono-dull-light')} />} label='Reports' />}
                value={3}
                disableRipple
                className='muiTab'
              />
              {data?.data.class.created_by === user?._id && (
                <Tab
                  label={<TabButton icon={<SettingsIcon className={clsx(tabValue === 4 ? 'fill-black' : 'fill-mono-dull-light')} />} label='Settings' />}
                  value={4}
                  disableRipple
                  className='muiTab'
                />
              )}
            </Tabs>
          </div>
          <div className='pageContent-single-tab'>
            <TabPanel value={tabValue} index={1}>
              <QuizClassOverview classInformation={data?.data} />
            </TabPanel>
            <TabPanel value={tabValue} index={2}>
              <StudentListTable />
            </TabPanel>
            <TabPanel value={tabValue} index={3}>
              <QuizReportsByClass classId={classId} />
            </TabPanel>
            <TabPanel index={4} value={tabValue}>
              <TeacherAccess classId={classId} schoolId={data?.data.class.school_id._id} />
            </TabPanel>
          </div>
        </div>
      </NavbarWrapper>
    </div>
  );
}
